export const types = {
  INIT_PURCHASE: 'MI_MOVISTAR_NO_CLIENT/INIT_PURCHASE',
  INIT_PURCHASE_SUCCESS: 'MI_MOVISTAR_NO_CLIENT/INIT_PURCHASE_SUCCESS',
  SET_INFO: 'MI_MOVISTAR_NO_CLIENT/SET_INFO',
  SET_INFO_SUCCESS: 'MI_MOVISTAR_NO_CLIENT/SET_INFO_SUCCESS',
  CHECKOUT_REQUEST: 'MI_MOVISTAR_NO_CLIENT/CHECKOUT_REQUEST',
  CHECKOUT_REQUEST_SUCCESS: 'MI_MOVISTAR_NO_CLIENT/CHECKOUT_REQUEST_SUCCESS',
  PROCESS_ORDER: 'MI_MOVISTAR_NO_CLIENT/PROCESS_ORDER',
  SET_SEGMENT: 'MI_MOVISTAR_NO_CLIENT/SET_SEGMENT',
  SET_MOBILE_LINES: 'MI_MOVISTAR_NO_CLIENT/SET_MOBILE_LINES',
  SEND_PURCHASE_OTP: 'MI_MOVISTAR_NO_CLIENT/SEND_PURCHASE_OTP',
  SEND_PORTABILITY_OTP: 'MI_MOVISTAR_NO_CLIENT/SEND_PORTABILITY_OTP',
  VALIDATE_PURCHASE_OTP: 'MI_MOVISTAR_NO_CLIENT/VALIDATE_PURCHASE_OTP',
  VALIDATE_PORTABILITY_OTP: 'MI_MOVISTAR_NO_CLIENT/VALIDATE_PORTABILITY_OTP',
  VALIDATE_ALL_OTPS: 'MI_MOVISTAR_NO_CLIENT/VALIDATE_ALL_OTPS',
};

export const actions = {
  initPurchase: (data) => ({
    type: types.INIT_PURCHASE,
    payload: { data },
  }),
  initPurchaseSuccess: (data) => ({
    type: types.INIT_PURCHASE_SUCCESS,
    payload: { data },
  }),
  setInfo: (data) => ({
    type: types.SET_INFO,
    payload: { data },
  }),
  setInfoSuccess: (data) => ({
    type: types.SET_INFO_SUCCESS,
    payload: { data },
  }),
  checkout: (data) => ({
    type: types.CHECKOUT_REQUEST,
    payload: { data },
  }),
  checkoutSuccess: (data) => ({
    type: types.CHECKOUT_REQUEST_SUCCESS,
    payload: { data },
  }),
  processOrder: (data) => ({
    type: types.PROCESS_ORDER,
    payload: { data },
  }),
  processOrderSuccess: (data) => ({
    type: types.PROCESS_ORDER_SUCCESS,
    payload: { data },
  }),
  setSegment: (data) => ({
    type: types.SET_SEGMENT,
    payload: { data },
  }),
  setMobileLines: (data) => ({
    type: types.SET_MOBILE_LINES,
    payload: { data },
  }),
  sendPurchaseOtp: (data) => ({
    type: types.SEND_PURCHASE_OTP,
    payload: { data },
  }),
  validatePurchaseOtp: (data) => ({
    type: types.VALIDATE_PURCHASE_OTP,
    payload: { data },
  }),
  sendPortabilityOtp: (data) => ({
    type: types.SEND_PORTABILITY_OTP,
    payload: { data },
  }),
  validatePortabilityOTP: (data) => ({
    type: types.VALIDATE_PORTABILITY_OTP,
    payload: { data },
  }),
  validateAllOTPs: (data) => ({
    type: types.VALIDATE_ALL_OTPS,
    payload: { data },
  }),
};

const initialState = {
  loadingForm: false,
  loadingShoppingCart: false,
  initialShoppingCart: null,
  shoppingCart: null,
  nextSteps: null,
  lines: null,
  shippingType: null,
  shippingTexts: null,
  checkout: false,
  segment: null,
  rentPayments: null,
};

/* eslint-disable default-param-last */
function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.INIT_PURCHASE: {
      return {
        ...state,
        loadingForm: true,
      };
    }
    case types.INIT_PURCHASE_SUCCESS: {
      const { data } = { ...action.payload };
      const {
        shoppingCartInfoNormalized,
        lines,
        shippingType = null,
        purchaseOptions,
        rentPayments,
        orionTexts,
        deliveryMethods,
      } = {
        ...data,
      };
      return {
        ...state,
        loadingForm: false,
        initialShoppingCart: shoppingCartInfoNormalized,
        shoppingCart: shoppingCartInfoNormalized,
        lines,
        shippingType,
        purchaseOptions,
        rentPayments,
        orionTexts,
        deliveryMethods,
      };
    }
    case types.SET_INFO: {
      const { data } = { ...action.payload };
      const { skipCheckCoverage } = { ...data };
      return {
        ...state,
        loadingShoppingCart: !skipCheckCoverage,
      };
    }
    case types.SET_INFO_SUCCESS: {
      const { data } = { ...action.payload };
      const {
        shoppingCart,
        shippingType,
        mobileLines,
        rentPayments,
        recommendation,
      } = {
        ...data,
      };
      return {
        ...state,
        loadingShoppingCart: false,
        shoppingCart,
        shippingType,
        mobileLines,
        rentPayments,
        recommendation,
      };
    }
    case types.CHECKOUT_REQUEST: {
      return {
        ...state,
        checkout: true,
      };
    }
    case types.CHECKOUT_REQUEST_SUCCESS: {
      return {
        ...state,
        checkout: false,
      };
    }
    case types.SET_SEGMENT: {
      const { data } = { ...action.payload };
      const { segment } = { ...data };
      return {
        ...state,
        segment,
      };
    }
    case types.SET_MOBILE_LINES: {
      const { data } = { ...action.payload };
      const { mobileLines } = { ...data };
      const newMobileLines = [...mobileLines];
      return {
        ...state,
        mobileLines: newMobileLines,
      };
    }
    default:
      return state;
  }
}

export default reducer;
